'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$OpenTo(action, item) {
  this.Dl = null;
  this.Dm = null;
  this.Dl = action;
  this.Dm = item;
}
export { $c_Lpresto_crud$OpenTo as $c_Lpresto_crud$OpenTo };
$p = $c_Lpresto_crud$OpenTo.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$OpenTo;
/** @constructor */
function $h_Lpresto_crud$OpenTo() {
}
export { $h_Lpresto_crud$OpenTo as $h_Lpresto_crud$OpenTo };
$h_Lpresto_crud$OpenTo.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_crud$OpenTo)) {
    var x = this.Dl;
    var x$2 = x$0.Dl;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.Dm;
      var x$4 = x$0.Dm;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "OpenTo";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Dl;
  }
  if ((n === 1)) {
    return this.Dm;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_crud$OpenTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j9)));
}
export { $isArrayOf_Lpresto_crud$OpenTo as $isArrayOf_Lpresto_crud$OpenTo };
var $d_Lpresto_crud$OpenTo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$OpenTo, "presto.crud$OpenTo", ({
  j9: 1,
  ca: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_crud$OpenTo as $d_Lpresto_crud$OpenTo };
//# sourceMappingURL=presto.crud$-Open-To.js.map
